<template>
    <div name="card-change-modal" class="wrapper">
        <loading v-if="isLoading" />
        <card-error-modal 
            v-if="cardError !== ''"
            :error="cardError"
            @onClose="closeModal"
        />
        <confirm-modal 
            @onClose="onInfoClose"
            @onYes="onInfoYes"
            v-if="isConfirm"
        />
        <div class="page">

            <error-modal 
                v-if="error"
                :error="error"
                @onClose="closeModal"
            />
            <img class="close" src="../../assets/close.png" @click="onClose"/>
            <span class="title">결제 카드를 등록해 주세요</span>
            <span class="default-text" style="margin-top: 16px;"><span class="bold">비대면진료/소모성재료 결제</span>를 위한 한 번의 카드 등록!</span>
            <!-- <span class="default-text" style="margin-top: 8px;"><span class="color">하나카드</span>는 현재 지원하지 않습니다.<br> 다른 카드사를 이용해 주세요.</span> -->
            <span class="default-text" style="margin-top: 8px;">변경 시 기존에 등록된 카드는 삭제됩니다.</span>

            <text-label 
                :text="'카드 번호'"
                :isDefault="true"
                style="margin-top: 10px;"
            />
            <div class="card-input" ref="cardInput"  >
                <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="text" maxlength="4" v-model="cardNumber1" placeholder="0000" inputmode="numeric" @input="moveToNext($event, 'cardNumber2')" @keydown="moveToPrev($event, null)" ref="cardNumber1"> -
                <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="text" maxlength="4" v-model="cardNumber2" placeholder="0000" inputmode="numeric" @input="moveToNext($event, 'cardNumber3')" @keydown="moveToPrev($event, 'cardNumber1')" ref="cardNumber2"> -
                <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="password" maxlength="4" v-model="cardNumber3" placeholder="0000" inputmode="numeric" @input="moveToNext($event, 'cardNumber4')" @keydown="moveToPrev($event, 'cardNumber2')" ref="cardNumber3"> -
                <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="password" maxlength="4" v-model="cardNumber4" placeholder="0000" inputmode="numeric" @keydown="moveToPrev($event, 'cardNumber3')" ref="cardNumber4">
            </div>
            <div class="error-info-text">{{ cardNumberError }}</div>
            <div class="direction-row">
                <div style="width:calc(50% - 4px)">
                    <text-label 
                        :text="'유효기간'"
                        :isDefault="true"
                    />
                    <input 
                        v-model="card_ex"
                        inputmode="numeric"
                        v-focus-background
                        placeholder="MM(월)/YY(연도)"
                        maxlength="4"
                        class="input-big"
                        ref="cardEx"
                    />
                    <div class="error-info-text">{{ cardExError }}</div>
                </div>
                <div  style="width:calc(50% - 4px)">   
                    <text-label 
                        :text="'비밀번호 앞 2자리'"
                        :isDefault="true"
                        style="font-size: 0px;"
                    />
                    <input
                        type="password"
                        inputmode="numeric"
                        maxlength="2"
                        class="input-big"
                        v-focus-background
                        placeholder="**"
                        v-model="card_pw"
                        ref="cardPw"
                    />
                    <div class="error-info-text">{{ cardPwError }}</div>
                </div>
            </div> 
            <text-label 
                :text="'이름 (카드 소유자)'"
                :isDefault="true"
            />
            <input 
                type="text"
                v-model="cardInfo.card_user_name"
                class="input-big"
                v-focus-background
                placeholder="이름을 적어주세요"
                ref="name"
            />            
            <div class="error-info-text">{{ nameError }}</div>
            <text-label 
                :text="'생년월일(사업자번호)'"
                :isDefault="true"
            />
            <input 
                type="text"
                inputmode="numeric"
                maxlength="10"
                v-model="birth"
                class="input-big"
                v-focus-background
                placeholder="주민번호 앞 6자리 또는 사업자번호 10자리"
                ref="birth"
            />   
            <div class="error-info-text">{{ birthError }}</div>
            <!-- agree area -->
            <div class="agree-area">
                <span class="agree-title">약관에 동의해 주세요<span class="red">*</span></span>
                <div class="agree-detail-box" style="margin-top: 16px">
                    <div class="row">
                        <check-box 
                            :checked="agreement_personal_info"
                            @onClick="() => {agreement_personal_info = !agreement_personal_info}"
                        />
                        <span @click="() => {agreement_personal_info = !agreement_personal_info}" class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 개인정보 수집 및 이용 동의</span>
                    </div>
                    <img style="width: 20px;cursor: pointer;" @click="openPolicy(2)" src="../../assets/detail.png" />
                </div>
                <div v-if="agreeError" class="error-info-text">이용약관에 동의해 주세요</div>
             </div>
            <div class="button-wrapper">                
                <bottom-button 
                    :text="'제출하기'"
                    :color="'#184FA1'"
                    @onClick="nextStep"
                />
            </div>
                <!-- footer -->
            <!-- <page-footer 
                :state="0"
            /> -->
        </div>
    </div>
</template>

<script>
import TextLabel from '@/components/atoms/TextLabel';
import {mapState} from 'vuex';
import focusBackground from '@/components/directives/focusBackground';
import focusInputCard from '@/components/directives/focusInputCard';
import BottomButton from '@/components/atoms/BottomButton';
import Loading from '@/components/molecules/Loading'
import ErrorModal from '@/components/modals/ErrorModal';
import CardErrorModal from '@/components/modals/CardErrorModal';
import CheckBox from '@/components/atoms/CheckBox';
import Convert from '@/utilities/convert';
import Constant from '@/constant';
import PageFooter from '@/components/molecules/PageFooter';
import ConfirmModal from '@/components/modals/ConfirmModal';

export default {
    name: 'cardChangeModal',
    props: ['token', 'profile_id'],
    computed: mapState(['cardInfo']),
    components: {
        BottomButton,
        TextLabel,
        Loading,
        ErrorModal,
        CardErrorModal,
        PageFooter,
        CheckBox,
        ConfirmModal
    },
    directives: {
        focusBackground,
        focusInputCard
    },
    data: function()
    {
        return {
            cardNumber1: '',
            cardNumber2: '',
            cardNumber3: '',
            cardNumber4: '',
            card_ex: '',
            card_pw: '',
            birth: '',
            isLoading: false,
            error: null,
            cardError: '',
            agreement_personal_info: false,
            agreeError: false,
            isUpdate: false,
            isConfirm: false,
            cardNumberError: '',
            cardExError: '',
            cardPwError: '',
            nameError: '',
            birthError: ''
        }
    },
    mounted: function()
    {
        document.getElementById('app').style.overflow = 'hidden';
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        document.documentElement.style.overflow = 'hidden';
        this.topFunction();
    },
    methods: {
        onInfoYes: function()
        {
            this.cardInfo.card_user_name = ''
            this.isConfirm = false;
            this.isUpdate = false;
            document.getElementById('app').style.overflow = 'auto';
            document.body.style.overflow = 'auto'; // 스크롤 비활성화
            document.documentElement.style.overflow = '';
            this.$emit('onClose', false)
        },
        onInfoClose: function()
        {
            this.isConfirm = false;
        },
        openPolicy: function(index)
        {   
            if(index === 1)
            {
                window.open("https://policy.soldoc.co.kr/terms", '_blank')
            }
            else if(index === 2)
            {
                window.open("https://policy.soldoc.co.kr/privacy-consent/payment", '_blank')
            }
            else if(index === 3)
            {
                window.open("https://policy.soldoc.co.kr/use", '_blank')
            }
            else if(index === 4)
            {
                window.open("https://policy.soldoc.co.kr/marketing", '_blank')
            }
        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        handleFocus: function()
        {
            this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
            this.$refs['cardInput'].style.border = "1px solid #184FA1"
        },
        handleFocusOut: function()
        {
            this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
            this.$refs['cardInput'].style.border = "1px solid #ccc"
        },
        moveToNext: function(event, nextField) {
            if (event.target.value.length === 4) {
                this.$refs[nextField].focus();
            }
        },
        moveToPrev: function(event, prevField) {
            if (event.key === 'Backspace' && event.target.value.length === 0 && prevField) {
                this.$refs[prevField].focus();
            }
        },
        errorFocus: function(field)
        {
            this.$refs[field].style.border = '1px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        },
        nextStep: function()
        {

            // 카드번호 각 자리별 자리수 확인, 숫자 확인
            // 유효기간
            if(this.cardNumber1.length != 4)
            {
                this.errorFocus('cardNumber1');
                this.cardNumberError = '카드번호를 입력해 주세요.';
                return;
            }
            if(this.cardNumber2.length != 4)
            {
                this.errorFocus('cardNumber2');
                this.cardNumberError = '카드번호를 입력해 주세요.';
                return;
            }
            if(this.cardNumber3.length != 4)
            {
                this.errorFocus('cardNumber3');
                this.cardNumberError = '카드번호를 입력해 주세요.';
                return;
            }
            if(this.cardNumber4.length < 3)
            {
                this.errorFocus('cardNumber4');
                this.cardNumberError = '카드번호를 입력해 주세요.';
                return;
            }

            this.cardInfo.card_number = this.cardNumber1 + this.cardNumber2 + this.cardNumber3 + this.cardNumber4;

            if(this.card_ex.length === 4)
            {
                this.cardInfo.card_ex_month = this.card_ex.substring(0, 2);
                this.cardInfo.card_ex_year = this.card_ex.substring(2, 4);
            }
            else 
            {
                this.errorFocus('cardEx');
                this.cardExError = '유효기간을 입력해 주세요. (예 MMYY)';
                return;
            }

            if(this.card_pw.length !== 2)
            {
                this.errorFocus('cardPw');
                this.cardPwError = '비밀번호 앞 2자를 입력 해주세요.';
                return;
            }
            if(this.cardInfo.card_user_name == '')
            {
                this.errorFocus('name');
                this.nameError = '이름을 입력해주세요. (한글 또는 영문만 가능)'
                return;
            }
            if(Convert.containsNumber(this.cardInfo.card_user_name))
            {
                this.errorFocus('name');
                this.nameError = '한글 또는 영문으로 입력해주세요.'
                return;
            }

            if(this.birth.length !== 6 && this.birth.length !== 10)
            {
                this.errorFocus('birth')
                this.birthError = '주민번호 앞 6자리 또는 사업자번호 10자리를 입력해주세요.';
                return;
            }

            if(this.birth.length === 6)
            {
                if(!Convert.isValidBirthdate(this.birth))
                {
                    this.errorFocus('birth')
                    this.birthError = '주민번호 앞 6자리 또는 사업자번호 10자리를 입력해주세요.';
                    return;
                }
            }

            if(!this.agreement_personal_info)
            {
                this.agreeError = true;
                return;
            }
                 
            this.cardInfo.card_pw = this.card_pw;
            this.cardInfo.card_nick_name = this.cardInfo.card_user_name;
            this.cardInfo.card_user_birth = this.birth;
            this.isLoading = true;
            this.duplicateDelegation = false;

            this.$store.dispatch(Constant.UPDATE_CARD, {profile_id: this.profile_id, token: this.token})
                .then(() => {

                    this.isLoading = false;
                    document.getElementById('app').style.overflow = 'auto';
                    document.body.style.overflow = 'auto'; // 스크롤 비활성화
                    document.documentElement.style.overflow = '';
                    this.$emit('onClose', true)
                    // alert("변경완료")

                })
                .catch((error) => {
                    
                    if(error.code.includes('PAYMENT'))
                    {
                        this.isLoading = false;
                        this.onCardError(error.message)
                    }
                    else
                    {
                        this.isLoading = false;
                        this.onError(error.message)
                    }
                })
        },
        onClose: function()
        {
            if(this.isUpdate)
            {
                this.isConfirm = true;
            }
            else
            {
                this.cardInfo.card_user_name = ''
                document.getElementById('app').style.overflow = 'auto';
                document.body.style.overflow = 'auto'; // 스크롤 비활성화
                document.documentElement.style.overflow = '';
                this.$emit('onClose', false)
            }            
            
        },
        onError: function(error){
            this.error = error;
        },  
        onCardError: function(error)
        {
            this.cardError = error;
        },
        closeModal: function()
        {
            this.error = null;
            this.cardError = '';
        }
    },
    watch: {
        cardNumber1: function(newValue)
        {
            this.isUpdate = true;
            this.cardNumber1 = newValue.replace(/[^0-9]/g, '');
            this.cardNumberError = '';
            if(this.cardNumber1.length === 4 || this.cardNumber1.length === 0)
            {
                // this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
                // this.$refs['cardInput'].style.border = "#f5f7fa"
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        cardNumber2: function(newValue)
        {
            this.isUpdate = true;
            this.cardNumber2 = newValue.replace(/[^0-9]/g, '');
            this.cardNumberError = '';
            if(this.cardNumber2.length === 4 || this.cardNumber2.length === 0)
            {
                // this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
                // this.$refs['cardInput'].style.border = "#f5f7fa"
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        cardNumber3: function(newValue)
        {
            this.isUpdate = true;
            this.cardNumber3 = newValue.replace(/[^0-9]/g, '');
            this.cardNumberError = '';
            if(this.cardNumber3.length === 4)
            {
                // this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        cardNumber4: function(newValue)
        {
            this.isUpdate = true;
            this.cardNumber4 = newValue.replace(/[^0-9]/g, '');
            this.cardNumberError = '';
            if(this.cardNumber4.length === 4)
            {
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        card_ex: function(newValue)
        {
            this.isUpdate = true;
            this.card_ex = newValue.replace(/[^0-9]/g, '');
            this.cardExError = '';
        },
        card_pw: function(newValue)
        {
            this.isUpdate = true;
            this.card_pw = newValue.replace(/[^0-9]/g, '');
            this.cardPwError = '';
        },
        birth: function(newValue)
        {
            this.isUpdate = true;
            this.birth = newValue.replace(/[^0-9]/g, '');
            this.birthError = '';
        },
        'cardInfo.card_user_name': function()
        {
            this.isUpdate = true;
            this.nameError = '';
        },
        agreement_personal_info: function()
        {
            this.isUpdate = true;
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        position: fixed;
        background: #fff;
        top: 0;
        overflow-y: auto;
    }
    .page {
        max-width: 600px;
        width: 100%;
        position: relative;
        padding: 49px 18px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }        
    }

    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .default-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
    }
    .bold {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 122.222% */
    }
    .color {
        color: var(--Blue-01_Primary-blue, #008DEF);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 122.222% */
    }
    .close {
        width: 22px;
        position: absolute;
        right: 21px;
        top: 14px;
        cursor: pointer;
    }   
    .input-area {
        width: 100%;
        padding: 40px 16px 30px 16px;
        border-bottom: 8px solid var(--Gray-sub-color1, #F3F5F8);
        box-sizing: border-box;
    }
    .direction-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
    }
    .card-input {
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        border-radius: 8px;
        background-color: #f5f7fa;
        width: 100%;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .input-small {
        width: calc(25%);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 0);
        border: 0;
        outline: none;
        box-sizing: border-box;
        text-align: center;
    }
    .input-big {
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .input-medium {
        width: calc(50% - 32px - 50px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        margin-right: 7px;
        box-sizing: border-box;
    }
    .button-wrapper {
        width: 100%;
        padding: 40px 0 30px 0;
        box-sizing: border-box;
    }
    /* agree */
    .agree-area {
        padding: 40px 16px 0 16px;
        width: 100%;
        box-sizing: border-box;
    }
    .agree-detail-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100%);
        box-sizing: border-box;
    }
    .agree-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-left: 17px;
    }
    .row {
        display: flex;
    }
    .error-info-text {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }
    .agree-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .red {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/CardChangeModal.vue